import { Link } from "react-router-dom";
import { Logo } from "@/lib/brand";
import { useCompany } from "@/lib/company";
import { SiteFooter } from "@/components/SiteFooter";
import { BackButton } from "@/components/BackButton";

export const LEGAL_UPDATED = "21 de outubro de 2026";
export const SUPPORT_HOURS = "segunda a sexta, 9h–18h (hora de Cabo Verde)";
const waLink = (phone) => `https://wa.me/${(phone || "").replace(/\D/g, "")}`;

export function useLegalInfo() {
  return useCompany();
}

export function IssuerBlock({ info }) {
  return (
    <p data-testid="legal-issuer">
      Entidade responsável: <b>{info.legal_name}</b> · NIF {info.nif} · Sede: {info.address}, Cabo Verde
      <br />Apoio: <a href={`mailto:${info.email}`} className="font-semibold text-petrol underline">{info.email}</a>
      {info.phone && <> · <a href={waLink(info.phone)} target="_blank" rel="noreferrer" className="font-semibold text-petrol underline" data-testid="legal-phone">{info.phone}</a> (telefone e WhatsApp)</>}
      <br />Horário: {SUPPORT_HOURS}
    </p>
  );
}

export function ProductOwnerNote({ info }) {
  return (
    <p data-testid="legal-owner">
      O {info.product_name || "GestaCV"} é um produto da <b>{info.legal_name}</b>, com NIF {info.nif} e sede em {info.address}, Cabo Verde, entidade responsável pelo serviço.
    </p>
  );
}

export function LiabilityText({ info }) {
  return (
    <ul data-testid="legal-liability">
      <li>A {info.legal_name} responde pelo funcionamento da plataforma GestaCV nos termos da lei de Cabo Verde.</li>
      <li>Não somos responsáveis por perdas indiretas (lucros cessantes, perda de negócio) nem por danos causados por uso indevido da conta, dados errados introduzidos pela empresa ou falhas de terceiros (rede, banco emissor, SISP, Stripe).</li>
      <li>Os documentos gerados na plataforma (orçamentos, pró-formas, recibos internos) são da responsabilidade da empresa que os emite.</li>
      <li>Salvo dolo ou negligência grave, a responsabilidade total fica limitada ao valor pago pela subscrição nos 12 meses anteriores ao facto.</li>
    </ul>
  );
}

export function LegalLayout({ title, children, testid }) {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800" data-testid={testid}>
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-4">
          <Link to="/"><Logo className="h-8 w-auto" /></Link>
          <BackButton fallback="/" testid="legal-back" />
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-5 py-12">
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-petrol sm:text-5xl">{title}</h1>
        <p className="mt-2 text-sm text-slate-500" data-testid="legal-updated">Última atualização: {LEGAL_UPDATED}</p>
        <div className="mt-8 space-y-6 text-[15px] leading-relaxed [&_h2]:mt-8 [&_h2]:font-display [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-petrol [&_li]:ml-5 [&_li]:list-disc">
          {children}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
